module.exports = __webpack_public_path__ + "img/logo5.2e9a1ae1.png";